



















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

import { statesList } from '@/utils/Utils';

// Components
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import RadioField from '@/components/Form/RadioField.vue';
import ClaimFormButton from './ClaimFormButton.vue';

@Component({
	name: 'PrimaryContactForThisEventorClaimFields',
	components: {
		ClaimFormButton,
		RadioField,
		SelectField,
		TextField,
	},
})
export default class PrimaryContactForThisEventorClaim extends Vue {
	@Prop() private values: any;
	@Prop() private input: any;
	@Prop() private blur: any;
	@Prop() private errors: any;
	@Prop() private touched: any;

	private statesList: typeof statesList = statesList;

	private addFile() {
		this.values.supportDocuments.files.push({
			file: '',
		});

		this.values.supportDocuments.fileLog.push({
			file_name: '',
			file_type: '',
			progress: 0,
			failed: false,
		});
	}

	private getDataUris(event, index) {
		const fileData = event.target.files[0];

		this.values.supportDocuments.fileLog[index].file_name = fileData.name;
		this.values.supportDocuments.fileLog[index].file_type = fileData.type;
		this.values.supportDocuments.files[index] = fileData;
	}

	private deleteFile(index) {
		if (confirm('Are you sure you want to delete the file?') === true) {
			this.values.supportDocuments.files.splice(index, 1);
			this.values.supportDocuments.fileLog.splice(index, 1);
			// this.getDataUris();
		}
	}
}
